import * as services from '@api'
import { sessionStorage } from 'ynf-core-middleware'

/**
 * 上翻、下翻
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  moveMode: string
 *  // 选填字段
 *  dataSourceAlias: string， 默认值：cardStore.dataSource
 *  cardStoreKey: string， 默认值：cardStore
 * }
 * @hooks {
 *  // 专有钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export const moveNextOrPrev = {
  async doAction(rootStore: any, options: any = {}) {
    const { moveMode = '', dataSourceAlias = '', cardStoreKey = 'cardStore' } = options
    const { pageStore = {}, utils = {} } = rootStore
    const { params = {}, query = {}, status = '' } = pageStore
    const cardStore = rootStore.get(cardStoreKey)
    const billNo = options.billNo || params.billNo;

    let actionParams = {}
    const CACHE_KEY = `moveActionParams_${billNo}` // 从列表页点击某一行的时候，存储的相关数据信息
    try {
      actionParams = JSON.parse(sessionStorage.getItem(CACHE_KEY))
    } catch (err: any) {
      console.error(err)
    }
    const billId = actionParams?.id ?? '' // 当前单据id
    const currentIndex = actionParams?.tableDataIds?.indexOf(billId) ?? -1 // 当前单据的索引值
    let moveBillId = billId // 要翻页的单据ID

    /**
   * @description: 是否需要调用翻页接口
   * @return {Boolean}
   */
    const shouldRequest = () => {
      let flag = false
      const len = actionParams?.tableDataIds?.length ?? 0
      if (moveMode === 'prev' && currentIndex === 0) { // 上翻 && 第一条数据
        flag = true
      } else if (moveMode === 'next' && currentIndex === len - 1) { // 下翻 && 最后一条数据
        flag = true
      }
      return flag
    }
    /**
   * @description: 获取要翻页的单据ID
   * @return {String} 单据IDs
   */
    const getMoveBillId = () => {
      let i = currentIndex
      if (moveMode === 'prev') {
        i -= 1
      } else if (moveMode === 'next') {
        i += 1
      }
      return actionParams?.tableDataIds?.[i] || billId
    }

    if (shouldRequest()) {
      try {
        pageStore?.startLoading?.()
        const res = await services.queryData4Move({
          params: {
            feV: 6,
            ...query,
            busiObj: options.busiObj || query.busiObj,
            datasource: dataSourceAlias || cardStore?.dataSource || '',
          },
          data: {
            billnum: billNo,
            extraCondition: actionParams?.condition ?? {},
            externalData: {
              moveMode
            },
            id: moveBillId,
            page: actionParams?.paging ?? {}
          }
        })
        if (res.code === 200) {
          const ids = res?.data?.pagers?.[0]?.data ?? []
          if (ids.length) {
            moveBillId = ids.at(moveMode === 'next' ? 0 : -1)
            actionParams['tableDataIds'] = ids
          }
        }
      } catch (err: any) {
        console.error(err)
      } finally {
        pageStore?.endLoading?.();
      }
    } else {
      moveBillId = getMoveBillId()
    }

    if (moveBillId !== billId) { // 非当前单据，才翻页
      // 更新缓存数据
      actionParams['id'] = moveBillId
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(actionParams))
      // 刷新单据详情
      pageStore.params.billId = moveBillId
      pageStore.bNeedRefresh = true
    } else { // 已经是 第一条 || 最后一条 || 当前单据
      utils.message.warning(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80054', '没有更多数据了'))
    }
  }
}
